import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import Pricing from "@/pages/Pricing";
import Install from "@/pages/Install";
import Security from "@/pages/Security";
import Dashboard from "@/pages/Dashboard";
import Profiles from "@/pages/Profiles";
import Medications from "@/pages/Medications";
import Vaccinations from "@/pages/Vaccinations";
import GrowthTracker from "@/pages/GrowthTracker";
import Appointments from "@/pages/Appointments";
import Contacts from "@/pages/Contacts";
import Insurance from "@/pages/Insurance";
import SickKidMode from "@/pages/SickKidMode";
import EmergencyView from "@/pages/EmergencyView";
import BillingSuccess from "@/pages/BillingSuccess";
import NotFound from "@/pages/NotFound";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Analytics from "@/components/Analytics";

function App() {
  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Analytics />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/install" element={<Install />} />
            <Route path="/security" element={<Security />} />
            <Route path="/billing/success" element={<BillingSuccess />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profiles" element={<Profiles />} />
              <Route path="/medications" element={<Medications />} />
              <Route path="/vaccinations" element={<Vaccinations />} />
              <Route path="/growth" element={<GrowthTracker />} />
              <Route path="/appointments" element={<Appointments />} />
              <Route path="/sick-kid" element={<SickKidMode />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/insurance" element={<Insurance />} />
              <Route path="/emergency" element={<EmergencyView />} />
            </Route>
            <Route path="/home" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;
